/**
 * Typed accessor for the Vibe Designer help-content config.
 *
 * All user-facing help COPY lives in helpContent.json (single source of truth,
 * per the 2026-06-27 directive: tooltip/help text in config, never inline in
 * components). This module just types it and re-exports the two collections.
 */
import raw from './helpContent.json';

export type TooltipKey =
  | 'viewDashboard'
  | 'viewDesigner'
  | 'viewKnowledge'
  | 'viewTerminals'
  | 'viewModules'
  | 'viewDeploys'
  | 'build'
  | 'cancelBuild'
  | 'deploy'
  | 'undeploy'
  | 'projectSwitcher'
  | 'settings'
  | 'deployConfirmAccept'
  | 'filesNewFile'
  | 'filesNewFolder'
  | 'filesRowActions'
  | 'helpButton';

export interface WalkthroughStep {
  id: string;
  /** CSS selector for the anchor element (drives tour spotlight + help-mode callout). */
  selector: string;
  title: string;
  body: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
}

const tooltips = raw.tooltips as Record<TooltipKey, string>;
const walkthrough = raw.walkthrough as WalkthroughStep[];

/** Native-title tooltip text by key. Falls back to '' for an unknown key. */
export function tip(key: TooltipKey): string {
  return tooltips[key] ?? '';
}

export { tooltips, walkthrough };
